import Pagination from "./Pagination.react";

export default Pagination;
